/**
 * Using the opencage API Forward Geocoding service
 */
import store from 'Site/js/store';
import ajax from 'Site/js/util/ajax.fetch';

export default async function (input, config = {}) {
    const opencage = store.state.siteConfig.data.openCageLocationApi;
    const { siteLocale } = store.state.siteConfig;
    const allItems = [];

    const route = 'https://api.opencagedata.com/geocode/v1/json';

    const options = {
        q: encodeURI(input),
        no_annotations: 1,
        limit: 10,
        language: siteLocale.substr(0, 2),
        proximity: `${opencage.latitude},${opencage.longitude}`,
        key: opencage.api,
    };

    const response = await ajax.get(route, options).catch(() => { throw new Error('opencage lookup failed'); });

    if (response) {
        let address;
        response.results.forEach((result) => {
            address = {
                formatted_address: result.formatted,
                lat: result.geometry.lat,
                lng: result.geometry.lng,
                ...(config.raw && {
                    address_components: result.components,
                }),
            };

            allItems.push(address);
        });
    }

    return allItems;
}
